import { createSelector } from '@reduxjs/toolkit';

export const selectData = (state) => state.fileTypes.data;
export const selectError = (state) => state.fileTypes.error;
export const selectLoading = (state) => state.fileTypes.loading;

export const selectDataAsMap = createSelector([selectData], (data) => {
  return data?.reduce((res, { code, value }) => {
    res[code] = value;
    return res;
  }, {});
});

export const selectFileTypeOptions = createSelector([selectData], (data) => {
  return data?.map(({ code, value }) => ({ title: value, value: code }));
});

export const selectCountOfFilesMap = createSelector([selectData], (data) => {
  return data?.reduce((res, { code, countOfFiles }) => {
    res[code] = countOfFiles;
    return res;
  }, {});
});

export const selectMergedFileTypeMapData = (state) => state.fileTypes.fileTypeMap.data;
export const selectMergedFileTypeMapError = (state) => state.fileTypes.fileTypeMap.error;
export const selectMergedFileTypeMapLoading = (state) => state.fileTypes.fileTypeMap.loading;
export const selectIsFileTypeEmpty = createSelector([selectMergedFileTypeMapData], (data) => {
  return !Object.keys(data)?.length;
});
